import {
  Transforms
} from 'slate';

import { nanoid } from 'nanoid';
import * as basicEditorValueSerializer from 'basic-editor-value-serializer';

import types from '../../elements/types';

import HelptapEditor from '../';

export function getDefaultOptions() {

  return basicEditorValueSerializer.utilities.node.paragraph.getDefaultOptions();

}

export function buildNode(options = {}) {

  const node = HelptapEditor.canvas.buildNode(options);

  node.type = types.VIDEO_CANVAS;
  node.properties.player = {
    durationInSeconds: 5,
    tracks: []
  };
  node.properties.url = node.properties.url.replace('image', 'video');
  const objects = node.properties.data.objects = [{
    rx: 0,
    ry: 0,
    id: nanoid(),
    type: 'Rect',
    version: '6.4.3',
    originX: 'left',
    originY: 'top',
    left: 594.5,
    top: 132,
    width: 50,
    height: 25,
    fill: '#a0c553',
    stroke: 'black',
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: true,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }, {
    radius: 25,
    startAngle: 0,
    endAngle: 360,
    counterClockwise: false,
    id: nanoid(),
    type: 'Circle',
    version: '6.4.3',
    originX: 'left',
    originY: 'top',
    left: 594.5,
    top: 119.5,
    width: 50,
    height: 50,
    fill: '#ffcd52',
    stroke: 'black',
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: true,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }, {
    rx: 0,
    ry: 0,
    id: nanoid(),
    type: 'Rect',
    version: '6.4.3',
    originX: 'left',
    originY: 'top',
    left: 594.5,
    top: 132,
    width: 50,
    height: 25,
    fill: '#01a2b6',
    stroke: 'black',
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: true,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }, {
    id: nanoid(),
    type: 'Triangle',
    version: '6.4.3',
    originX: 'left',
    originY: 'top',
    left: 594.5,
    top: 119.5,
    width: 50,
    height: 50,
    fill: '#ea5f66',
    stroke: 'black',
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: true,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }, {
    fontSize: 24,
    fontWeight: 'normal',
    fontFamily: 'Arial',
    fontStyle: 'normal',
    lineHeight: 1.16,
    text: 'Let\'s make a video ',
    charSpacing: 0,
    textAlign: 'center',
    styles: [],
    pathStartOffset: 0,
    pathSide: 'left',
    pathAlign: 'baseline',
    underline: false,
    overline: false,
    linethrough: false,
    textBackgroundColor: '',
    direction: 'ltr',
    minWidth: 20,
    splitByGrapheme: false,
    id: nanoid(),
    type: 'Textbox',
    version: '6.4.3',
    originX: 'left',
    originY: 'top',
    left: 544.5,
    top: 130.94,
    width: 150,
    height: 58.5792,
    fill: '#1a1a1a',
    stroke: null,
    strokeWidth: 1,
    strokeDashArray: null,
    strokeLineCap: 'butt',
    strokeDashOffset: 0,
    strokeLineJoin: 'miter',
    strokeUniform: true,
    strokeMiterLimit: 4,
    scaleX: 1,
    scaleY: 1,
    angle: 0,
    flipX: false,
    flipY: false,
    opacity: 1,
    shadow: null,
    visible: true,
    backgroundColor: '',
    fillRule: 'nonzero',
    paintFirst: 'fill',
    globalCompositeOperation: 'source-over',
    skewX: 0,
    skewY: 0
  }];

  node.properties.player.tracks = [{
    id: objects[0].id,
    type: objects[0].type,
    start: 0,
    duration: 1,
    name: `${objects[0].type} #1`
  }, {
    id: objects[1].id,
    type: objects[1].type,
    start: 1,
    duration: 1,
    name: `${objects[1].type} #1`
  }, {
    id: objects[2].id,
    type: objects[2].type,
    start: 2,
    duration: 1,
    name: `${objects[2].type} #2`
  }, {
    id: objects[3].id,
    type: objects[3].type,
    start: 3,
    duration: 1,
    name: `${objects[3].type} #1`
  }, {
    id: objects[4].id,
    type: objects[4].type,
    start: 4,
    duration: 1,
    name: `${objects[4].type} #1`
  }];

  return node;

}

export function insert(...parameters) {
  HelptapEditor.canvas.insert(...parameters);
}

export function toggle(editor, options, editorOptions, targetNodePath, nextNodePath) {

  const nodeOptions = buildNode(options);

  HelptapEditor.setNodeOptions(editor, nodeOptions);
  HelptapEditor.paragraph.insert(editor, nextNodePath);
  Transforms.select(editor, [...targetNodePath]);
}

export function duplicate(...parameters) {
  HelptapEditor.canvas.duplicate(...parameters);
}

export function isVideoCanvasNode(node) {

  return node.type === types.VIDEO_CANVAS;

}